import React, { useEffect, useState } from 'react';
import styles from './WorkFlowBar.module.scss';
import ChatHeader from './components/ChatHeader';
import SvgWithBranding from 'component/hoc/branding/withBrandingColor.hoc';
import { useFetch } from 'hooks/useFetch';
import { workflow } from 'hooks/endpoints';
import { useNavigate } from 'react-router-dom';
import NewWorkflow from 'component/organism/settings-workflow/new-workflow/NewWorkflow';
import Loader from 'component/atom/loader/Loader';

const WorkFlowBar = ({ isOpen, setIsOpen, setFlag, botId, refetch }) => {
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [isExpanded, setIsExpanded] = useState(false);

  const {
    data: workFlowData,
    isFetching,
    refetch: refetchData,
  } = useFetch(
    ['pagedWorkflowData', botId],
    workflow.getAllWorkflowsPaged,
    {
      enabled: false,
    },
    {
      pageSize: 100,
      pageNumber: 1,
      botId: botId,
    }
  );

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  const handleSearchFlows = (term) => {
    return workFlowData?.data?.items.filter((item) =>
      item.name.toLowerCase().includes(term.toLowerCase())
    );
  };

  useEffect(() => {
    if (botId != undefined) {
      refetchData();
    }
  }, [botId]);

  const filteredItems = handleSearchFlows(searchTerm);

  return (
    <div
      className={`${styles['chat-sidebar']} ${
        isExpanded ? styles['expanded'] : styles['collapsed']
      }`}
    >
      <ChatHeader
        onMenuClick={setIsOpen}
        isOpen={isOpen}
        handleExpand={handleExpand}
        isExpanded={isExpanded}
        isWorkflow
      />
      <div
        className={`${styles['chat-body']} ${
          isExpanded ? styles['expanded'] : styles['collapsed']
        }`}
      >
        <div className={styles['content']}>
          <p
            onClick={() => setIsModalOpen(true)}
            className={styles['create-new']}
          >
            Create New
          </p>
          <div className={styles['search-container']}>
            <SvgWithBranding type='search' color='black' />
            <input
              type='text'
              placeholder='Search'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
          {isFetching ? (
            <Loader isComponent />
          ) : (
            <div className={styles['inner-container']}>
              {filteredItems?.map((val) => (
                <p
                  key={val?.id}
                  className={styles['text']}
                  onClick={() => {
                    setFlag(false);
                    // setWorkflowData({});
                    setIsExpanded(!isExpanded);
                    navigate(`/workflow/${val.id}`);
                    window.location.reload();
                    refetch();
                  }}
                >
                  {val?.name}
                </p>
              ))}
            </div>
          )}
        </div>
      </div>
      <NewWorkflow
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        setRefetch={refetchData}
        id={botId}
      />
    </div>
  );
};

export default WorkFlowBar;
